// @file Functions related to tracking font loading with browser's document.font
// Font variant string is an accepted input of document.fonts.load. e.g. "16px Arial"
declare global {
  interface Document {
    fonts?: any
  }
}

const trackedFonts: Record<string, boolean> = {}

export function isFontVariantLoadedTracked(fontVariant: string): boolean {
  return trackedFonts[fontVariant] !== undefined
}
export function isFontVariantLoaded(fontVariant): boolean {
  return trackedFonts[fontVariant]
}

export async function trackFontVariantLoaded(fontVariant: string): Promise<boolean> {
  if (trackedFonts[fontVariant]) {
    return trackedFonts[fontVariant]
  }
  if (!document.fonts && document.readyState === 'complete') {
    // If FontFaceSet API is not supported, we fallback to DOM ready state
    trackedFonts[fontVariant] = true
    return true
  }

  if (!document.fonts) {
    const result = await new Promise<boolean>((resolve) => {
      window.addEventListener('DOMContentLoaded', () => {
        // If FontFaceSet API is not supported, we fallback to DOM ready state
        trackedFonts[fontVariant] = true
        resolve(true)
      })
    })
    return result
  }
  if (document.fonts) {
    await document.fonts.ready
    const fontsLoaded = await document.fonts.load(fontVariant)
    trackedFonts[fontVariant] = fontsLoaded.length > 0
    return trackedFonts[fontVariant]
  }
  return true
}
